
<template>
    <div class="main">
        <div class="home">
            <breadcrumb></breadcrumb>
            <div style="padding: 10px 30px 20px 0px;">
                <el-row>
                    <el-col :span="6">
                        <div>
                            <sideNavigation></sideNavigation>
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-form v-loading="loading">
                            <div class="liContent">
                                <el-row v-for="(item,index) in tableData" :key="index" class="cardListPage-list"
                                        @click.native="listsClick(item)">
                                    <el-col :span="18" class="cardListPage-lists-col">{{item.title}}</el-col>
                                    <el-col :span="6" style="text-align: right; color: #999990;font-size: 14px">{{item.publishTime | formatDate}}</el-col>
                                </el-row>
                            </div>
                            <div style="margin-top: 20px" v-if="tableData && tableData.length > 0">
                                <div class="pagination">
                                    <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            :current-page="pagination.pageNum"
                                            :page-sizes="[5, 10, 15, 20]"
                                            :page-size="pagination.pageSize"
                                            background
                                            layout="total, sizes,prev, pager, next,jumper"
                                            :total="pagination.count"
                                            prev-text="上一页"
                                            next-text="下一页">
                                    </el-pagination>
                                </div>
                            </div>
                            <div v-else>
                                <span style="display: inline-block;margin-top: 30px">暂无热点信息!</span>
                            </div>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatDate} from "@/utils/format"
    import sideNavigation from "@/components/sideNavigation"
    import breadcrumb from "@/components/breadcrumb"

    export default {
        data() {
            return {
                loading: true,
                date: [],
                content: '',
                form: {
                    pageSize: 5
                },
                pagination: {
                    count: 0,   //总页数
                    pageSize: 10,  //每页限制
                    pages: 0,
                    pageNum: 1,  //当前页
                    list: []
                },

                tableData: [],
                checked: true,
                activeName: 'first',
                activeName1: 'first',
                activeName2: 'first'
            }
        },
        filters: {
            formatDate(time) {
                var data = new Date(time);
                return formatDate(data, 'yyyy-MM-dd');
            }
        },
        mounted() {
            this.PageSelect()
        },
        methods: {
            handleClick(tab, event) {

            },

            //标题跳转页面
            listsClick(res) {
                this.$router.push({
                    path: '/zwgk-door-textContent',
                    query: {
                        name: '查看文章详情内容',
                        id: 12,
                        id4: res.id
                    }
                })
                // this.$store.commit("setDetails",res)
            },

            // 分页查询
            PageSelect() {
                // this.pagination.pageNum = 1;
                this.form.pageSize = this.pagination.pageSize;
                this.form.pageNum = this.pagination.pageNum;
                this.$axios({
                    url: '/rdApplication/queryAll',
                    method: 'post',
                    data: this.$axios.encrypt(this.form)
                }).then(({data}) => {
                    const that = this
                    // that.tableData = data.result
                    // console.log(data.result)
                    that.pagination = data;
                    that.tableData = data.result
                    this.loading =  false

                })
            },

            //每页下拉显示数据
            handleSizeChange: function (size) {
                this.pagination.pageSize = size;
                this.PageSelect();
            },

            //点击第几页
            handleCurrentChange: function (pageNum) {
                this.pagination.pageNum = pageNum;
                this.PageSelect();
            },

            //  parseTime(time, cFormat) {
            //     if (arguments.length === 0) {
            //         return null
            //     }
            //     const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
            //     let date
            //     if (typeof time === 'object') {
            //         date = time
            //     } else {
            //         if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            //             time = parseInt(time)
            //         }
            //         if ((typeof time === 'number') && (time.toString().length === 10)) {
            //             time = time * 1000
            //         }
            //         date = new Date(time)
            //     }
            //     const formatObj = {
            //         y: date.getFullYear(),
            //         m: date.getMonth() + 1,
            //         d: date.getDate(),
            //         h: date.getHours(),
            //         i: date.getMinutes(),
            //         s: date.getSeconds(),
            //         a: date.getDay()
            //     }
            //     const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
            //         let value = formatObj[key]
            //         if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
            //         if (result.length > 0 && value < 10) {
            //             value = '0' + value
            //         }
            //         return value || 0
            //     })
            //     return time_str
            // }
        },
        components: {
            sideNavigation,
            breadcrumb
        }
    }
</script>

<style>
    .text {
        text-align: center;
        padding: 20px 10px;
        width: 60%;
        margin: 20px auto 0px;
    }

    .text .liContent {
        height: 400px;
    }

    .text .middle span {
        float: right;
    }

    .text .middle-line {
        width: 100%;
        border: 1px dotted #f5dea9;
        margin: 20px 0px;
    }

    .text .tabs {
        text-align: left;
        margin-left: 20px;
        margin-bottom: 20px;
    }

    .text .tabs li {
        margin: 8px 0px;
        color: #5f5f5f;
        font-size: 14px;
    }

    .cardListPage-lists {
        text-align: left;
    }

    .cardListPage-list {
        cursor: pointer;
        height: 46px;
        line-height: 46px;
        border-bottom: 1px solid #DDDDDD;
    }

    .cardListPage-lists-border {
        border-bottom: 1px dashed #e4e4e4;
    }

    .cardListPage-lists-col {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #7F848D;
        text-align: left;
        padding-left: 16px;
    }
    .cardListPage-lists-col:before{
        content: "";
        width: 7px;
        border-radius: 50px;
        height: 7px;
        background-color: #008cff;
        top: 20px;
        position: absolute;
        left: -7px;
    }

    .cardListPage-pagination {
        margin-top: 6px;
    }

    .el-pagination {
        margin: initial;
    }
</style>
